import React from "react";
import StaxCheckoutForm from "./StaxCheckoutForm";

const StaxCheckoutPage = ({ amount, onSuccess, onClose }) => {
    return (
        <StaxCheckoutForm
            amount={amount}
            onSuccess={onSuccess}
            onClose={onClose}
        />
    );
};

export default StaxCheckoutPage;